import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Card,
  Stack,
  Drawer,
  Chip,
  Divider,
  TextField
} from "@mui/material";
import { Tooltip } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import {
  fetchRoomsCalendar,
  updateTarif,
  updateInventory,
  updateStatus,
} from "./inventoryService.js";
import InventoryGrid from "./InventoryGrid.jsx";


const Rooms = () => {
  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;
  
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectionStart, setSelectionStart] = useState(null);
  const [selectedDays, setSelectedDays] = useState({
    tarif: [],
    inventory: [],
    status: []
  });
  const [isSelecting, setIsSelecting] = useState(false);
  const [editModeRoom, setEditModeRoom] = useState(null);
  const [editType, setEditType] = useState(null); // "tarif" ou "inventory"
  const [newValue, setNewValue] = useState("");
  const [startIndex, setStartIndex] = useState(0);
  const daysPerPage = 10;
  const [rooms, setRooms] = useState([]);
  
  
// Récupérer les tarifs du mois
const fetchRooms = async () => {
  const start = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    1
  );

  const end = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth() + 1,
    0
  );

  const startDate = start.toISOString().split("T")[0];
  const endDate = end.toISOString().split("T")[0];

  try {
    const merged = await fetchRoomsCalendar(
      hotelId,
      startDate,
      endDate
    );

    setRooms(merged);
    console.log(rooms)
  } catch (err) {
    console.error(err);
  }
};

    useEffect(() => {
    

    fetchRooms();
    }, [currentMonth, hotelId]);


   
    useEffect(() => {
      setStartIndex(0);
      }, [currentMonth]);  
useEffect(() => {
  const stopSelecting = () => {
    setIsSelecting(false);
    setSelectionStart(null);
  };

  window.addEventListener("mouseup", stopSelecting);

  return () => {
    window.removeEventListener("mouseup", stopSelecting);
  };
}, []);
const handleApply = async () => {
  if (newValue === "" || newValue === null) return;

  const range = getSelectedDateRange();
  if (!range) return;

  const { dateDebut, dateFin } = range;

  try {
    if (editType === "tarif") {
      await updateTarif(editModeRoom, dateDebut, dateFin, parseInt(newValue));
    } else if (editType === "inventory") {
      await updateInventory(editModeRoom, dateDebut, dateFin, parseInt(newValue));
    }

    setSelectedDays({
      tarif: [],
      inventory: [],
      status: [],
    });

    setEditType(null);
    setEditModeRoom(null);
    setNewValue("");

    await fetchRooms();
  } catch (err) {
    console.error(err);
  }
};

  const handleStatusUpdate = async (newStatus) => {
  const selectedDates = selectedDays.status
    .map(index => daysOfMonth[startIndex + index])
    .sort((a, b) => new Date(a) - new Date(b));

  const dateDebut = selectedDates[0];
  const dateFin = selectedDates[selectedDates.length - 1];

  try {
    await updateStatus(editModeRoom, dateDebut, dateFin, newStatus);

    setSelectedDays({
      tarif: [],
      inventory: [],
      status: []
    });

    setEditType(null);
    setEditModeRoom(null);

    await fetchRooms(); // refresh propre

  } catch (err) {
    console.error(err);
  }
};


  const getDaysOfMonth = () => {
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  return Array.from({ length: daysInMonth }, (_, i) => {
    const date = new Date(year, month, i + 1);
    return date.toISOString().split("T")[0];
  });
};
const daysOfMonth = getDaysOfMonth();

  const changeMonth = (dir) => {
    const newDate = new Date(currentMonth);
    newDate.setMonth(currentMonth.getMonth() + dir);
    setCurrentMonth(newDate);
  };

  const getSelectedDateRange = () => {
  if (!editType) return null;

  const selectedIndexes = selectedDays[editType];

  if (!selectedIndexes || selectedIndexes.length === 0)
    return null;

  const realIndexes = selectedIndexes.map(
    (i) => startIndex + i
  );

  const sorted = [...realIndexes].sort((a, b) => a - b);

  const dateDebut = daysOfMonth[sorted[0]];
  const dateFin =
    daysOfMonth[sorted[sorted.length - 1]];

  if (!dateDebut || !dateFin) return null;

  return { dateDebut, dateFin };
};

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#F8FAFC",

      }}
    >
      {/* HEADER */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={6}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#0F172A",
              letterSpacing: "-0.5px",
            }}
          >
            Gestion des Chambres
          </Typography>
          <Typography sx={{ color: "#64748B", mt: 1 }}>
            Inventaire et disponibilités mensuelles
          </Typography>
        </Box>

        
      </Stack>

      {/* MONTH SELECTOR */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        mb={7}
        spacing={3}
      >
        <IconButton onClick={() => changeMonth(-1)}>
          <ArrowBackIosNew fontSize="small" />
        </IconButton>

        <Typography
          sx={{
            fontSize: "1.1rem",
            fontWeight: 600,
            color: "#0F172A",
            minWidth: 180,
            textAlign: "center",
          }}
        >
          {(() => {
            const month = currentMonth.toLocaleString("fr-FR", {
              month: "long",
              year: "numeric",
            });

            return month.charAt(0).toUpperCase() + month.slice(1);
          })()}
        </Typography>

        <IconButton onClick={() => changeMonth(1)}>
          <ArrowForwardIos fontSize="small" />
        </IconButton>
      </Stack>
      <Stack direction="row" justifyContent="center" spacing={3} mb={4}>
        <Button
          disabled={startIndex === 0}
          onClick={() => setStartIndex(prev => prev - daysPerPage)}
        >
          ←
        </Button>

        <Typography fontWeight={600}>
          Jours {startIndex + 1} à{" "}
          {Math.min(startIndex + daysPerPage, daysOfMonth.length)}
        </Typography>

        <Button
          disabled={startIndex + daysPerPage >= daysOfMonth.length}
          onClick={() => setStartIndex(prev => prev + daysPerPage)}
        >
          →
        </Button>
      </Stack>

      {/* ROOMS */}
      <Stack spacing={5}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `120px repeat(${daysPerPage}, 1fr)`,
            mb: 2,
            border: "1px solid #E2E8F0",
            borderRadius: 3,
            overflow: "hidden",
            backgroundColor: "#F8FAFC",
          }}
        >
          {/* Case vide à gauche */}
          <Box
            sx={{
              borderRight: "1px solid #E2E8F0",
              px: 2,
              py: 2,
              fontWeight: 600,
            }}
          >
            Chambre
          </Box>

          {daysOfMonth
            .slice(startIndex, startIndex + daysPerPage)
            .map((dateStr, index) => {

              const date = new Date(dateStr);

              const today = new Date().toISOString().split("T")[0];
              const isToday = dateStr === today;
              const day = new Date(dateStr).getDay();
              const isWeekend = day === 0 || day === 6;

              return (
                <Box
                  key={index}
                  sx={{
                    borderLeft: "1px solid #E2E8F0",
                    px: 1,
                    py: 2,
                    textAlign: "center",
                    backgroundColor: isToday ? "#EEF2FF" : isWeekend ? "#eff2f5" : undefined,
                    
                  }}
                >
                  <Typography fontWeight={600} fontSize={14}>
                    {date.getDate()}
                  </Typography>

                  <Typography
                    fontSize={11}
                    sx={{ color: "#64748B" }}
                  >
                    {date.toLocaleDateString("fr-FR", {
                      weekday: "short",
                    })}
                  </Typography>
                </Box>
              );
            })}
        </Box>
        {rooms.map((room) => (
            <InventoryGrid
                key={room.roomId}
                room={room}
                daysOfMonth={daysOfMonth}
                startIndex={startIndex}
                daysPerPage={daysPerPage}
                selectedDays={selectedDays}
                setSelectedDays={setSelectedDays}
                editType={editType}
                setEditType={setEditType}
                editModeRoom={editModeRoom}
                setEditModeRoom={setEditModeRoom}
                isSelecting={isSelecting}
                setIsSelecting={setIsSelecting}
                handleApply={handleApply}
                handleStatusUpdate={handleStatusUpdate}
                newValue={newValue}
                setNewValue={setNewValue}
                selectionStart={selectionStart}
                setSelectionStart={setSelectionStart}
                hotelId={hotelId}
                
            />
            ))}
          {editType &&
            selectedDays[editType]?.length > 0 && (
              <Box
                sx={{
                  position: "fixed",
                  bottom: 30,
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  borderRadius: 3,
                  px: 4,
                  py: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  zIndex: 2000,
                }}
              >
                <Typography fontWeight={600}>
                  Modifier {selectedDays[editType].length} jour(s)
                </Typography>

                {editType === "status" ? (
                  <>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => handleStatusUpdate("opened")}
                    >
                      Ouvrir
                    </Button>

                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => handleStatusUpdate("closed")}
                    >
                      Fermer
                    </Button>
                  </>
                ) : (
                  <>
                    <input
                      type="number"
                      placeholder={
                        editType === "tarif"
                          ? "Nouveau prix"
                          : "Nouvelle dispo"
                      }
                      value={newValue}
                      onChange={(e) => setNewValue(e.target.value)}
                      style={{
                        padding: "8px 12px",
                        borderRadius: "8px",
                        border: "1px solid #CBD5E1",
                      }}
                    />

                    <Button
                      variant="contained"
                      onClick={handleApply}
                    >
                      Appliquer
                    </Button>
                  </>
                )}

                <Button
                  variant="text"
                  onClick={() => {
                    setSelectedDays({
                      tarif: [],
                      inventory: [],
                      status: [],
                    });
                    setEditType(null);
                    setEditModeRoom(null);
                    setNewValue("");
                  }}
                >
                  Annuler
                </Button>
              </Box>
          )}
      </Stack>

      
    </Box>
  );
};

export default Rooms;